import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { GetJson } from '@awp/helpers/fetchReact';
import { REST_API, STATE_STATUS } from '@awp/constants';
import { EventTypes } from '@awp/constants';

const initialState = {
  status: {
    properties: STATE_STATUS.IDLE,
    types: STATE_STATUS.IDLE,
  },
  properties: [],
  types: [],
};

export const selectAllEventProperties = (state) => state.event.properties;
export const selectAllEventTypes = (state) => state.event.types; //this has all the fields

//for dropdowns
export const selectEventTypes = (state) => getEventTypes(state);
export const selectMainEventTypes = (state) => getMainEventTypes(state);
export const selectPhasedEventTypes = (state) => getPhasedEventTypes(state);

export const fetchEventPropertyData = createAsyncThunk('event/fetchEventPropertyData', async () => {
  let url = REST_API.EVENT_PROPERTY;
  const res = await GetJson(url);
  return await res.json();
});

export const fetchEventTypeData = createAsyncThunk('event/fetchEventTypeData', async () => {
  let url = REST_API.EVENT_TYPES;
  const res = await GetJson(url);
  return await res.json();
});

/**
 * SELECTORS
 */
export const getEventPropertiesByTypeId = createSelector(
  [(state) => state.event.properties, (_, typeId) => typeId],
  (properties, typeId) => {
    return properties
      .filter(({ EventTypeId }) => EventTypeId === typeId)
      .sort((a, b) => {
        return a.DisplayOrder < b.DisplayOrder ? -1 : a.DisplayOrder > b.DisplayOrder ? 1 : 0;
      });
  },
);

export const getEventPropertiesByTypeName = createSelector(
  [(state) => state.event.properties, (_, typeName) => typeName],
  (properties, typeName) => {
    return properties
      .filter(({ EventName }) => EventName === typeName)
      .sort((a, b) => {
        return a.DisplayOrder < b.DisplayOrder ? -1 : a.DisplayOrder > b.DisplayOrder ? 1 : 0;
      });
  },
);
export const getOptionalEventPropertiesByTypeName = createSelector(
  [(state) => state.event.properties, (_, typeName) => typeName],
  (properties, typeName) => {
    return properties
      .filter(({ EventName, IsMandatory }) => EventName === typeName && IsMandatory !== 'Y')
      .sort((a, b) => {
        return a.DisplayOrder < b.DisplayOrder ? -1 : a.DisplayOrder > b.DisplayOrder ? 1 : 0;
      });
  },
);

export const getEventTypes = createSelector([(state) => state.event.types], (types) => {
  return types.map((e) => {
    return { value: e.Name, label: e.DisplayName, Abbreviation: e.Abbreviation };
  });
});

export const getMainEventTypes = createSelector([(state) => state.event.types], (types) => {
  return types
    .filter((e) => e.ParentEventTypeId === null)
    .map((e) => {
      return { value: e.Name, label: e.DisplayName, Abbreviation: e.Abbreviation };
    });
});

export const getPhasedEventTypes = createSelector([(state) => state.event.types], (types) => {
  const rcEventId = types.find((e) => e.Name === EventTypes.RoadClosure)?.Id;
  return types
    .filter((e) => e.ParentEventTypeId === rcEventId)
    .map((e) => {
      return {
        value: e.Name,
        label: e.DisplayName,
        Abbreviation: e.Abbreviation,
        order: e.ChronologicalOrder,
        isDisabled: false,
      };
    });
});

export const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchEventPropertyData.pending]: (state) => {
      state.status.properties = STATE_STATUS.LOADING;
    },
    [fetchEventPropertyData.fulfilled]: (state, action) => {
      state.status.properties = STATE_STATUS.SUCCESS;
      state.properties = action.payload;
    },
    [fetchEventPropertyData.rejected]: (state, action) => {
      state.status.properties = STATE_STATUS.FAILED;
      state.error = action.error.message;
    },
    [fetchEventTypeData.pending]: (state) => {
      state.status.types = STATE_STATUS.LOADING;
    },
    [fetchEventTypeData.fulfilled]: (state, action) => {
      state.status.types = STATE_STATUS.SUCCESS;
      state.types = action.payload;
    },
    [fetchEventTypeData.rejected]: (state, action) => {
      state.status.types = STATE_STATUS.FAILED;
      state.error = action.error.message;
    },
  },
});
